import exists from './exists';

const toString = (thing: any) => (exists(thing) ? String(thing) : '');

const toLowerCaseString = (thing: any): string => toString(thing).toLowerCase();

export default toLowerCaseString;
